import { MutationKeyConfig, QueryKeyConfig } from './api-helper';

export const qbApiKeyStore = {
  // qbologin: (): QueryKeyConfig => ({
  //   queryKey: [`QB_LOGIN`],
  //   route: `/connect/qbologin`,
  // }),
  // qbologin: (): MutationKeyConfig => ({
  //   mutationKey: [`QB_LOGIN`],
  //   route: `/connect/qbologin`,
  //   action: 'POST',
  // }),
  qbologin: (): MutationKeyConfig => ({
    mutationKey: [`QB_LOGIN`],
    route: `/connect/qbologin`,
    action: 'POST',
  }),

  qbotoken: (): MutationKeyConfig => ({
    mutationKey: [`QB_TOKEN`],
    route: `/connect/qbotoken`,
    action: 'POST',
  }),

  // qbotoken: (code: string, realmId: number, state: string): QueryKeyConfig => ({
  //   queryKey: [`QB_TOKEN`],
  //   route: `/connect/qbotoken?code=${code}&realmId=${realmId}&state=${state}`,
  // }),

  qbostate: (): QueryKeyConfig => ({
    queryKey: [`QB_STATUS`],
    route: `/connect/qbostate`,
  }),
};
